module.exports = __webpack_public_path__ + "assets/fuqinjie.6f70177f.svg";